import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";

// Layout
import DashboardLayout from "./components/layout/DashboardLayout";

// Auth Pages
import Login from "./pages/Login";
import SetPassword from "./pages/SetPassword";
import ForgotPassword from "./pages/ForgotPassword";

// Dashboard Pages
import Dashboard from "./pages/Dashboard";
import TrainingList from "./pages/TrainingList";
import Quizzes from "./pages/Quizzes";
import SOPLibrary from "./pages/SOPLibrary";
import Curricula from "./pages/Curricula";
import Assignments from "./pages/Assignments";
import Reports from "./pages/Reports";
import Onboarding from "./pages/Onboarding";
import OnboardingWorkflow from "./pages/OnboardingWorkflow";
import OnboardingDashboard from "./pages/OnboardingDashboard";
import Certifications from "./pages/Certifications";
import Users from "./pages/Users";
import Settings from "./pages/Settings";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/set-password" element={<SetPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          
          {/* Protected Dashboard Routes */}
          <Route path="/" element={<DashboardLayout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="trainings" element={<TrainingList />} />
            <Route path="quizzes" element={<Quizzes />} />
            <Route path="sops" element={<SOPLibrary />} />
            <Route path="curricula" element={<Curricula />} />
            <Route path="assignments" element={<Assignments />} />
            <Route path="reports" element={<Reports />} />
            <Route path="certifications" element={<Certifications />} />
            <Route path="onboarding" element={<OnboardingWorkflow />} />
            <Route path="onboarding-checklist" element={<Onboarding />} />
            <Route path="onboarding-dashboard" element={<OnboardingDashboard />} />
            <Route path="users" element={<Users />} />
            <Route path="settings" element={<Settings />} />
          </Route>

          {/* Catch all */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
